




























































import { AxiosResponse } from "axios";
import Vue from "vue";
import { itemApi } from "../../utils/axios";

export default Vue.extend({
  name: "Filters",

  props: {
    filters: Object
  },
  data: () => ({
    Si: [],
    Gu: [],
    Category: ["전자기기","의류","미용","잡화","도서"]
  }),
  methods: {
    getGu(data: String) {
      // 구 찾기
      itemApi.search(this.filters.si).then((res: AxiosResponse) => {
        this.Gu = res.data.object.gungu;
      })
    },
    reset() {
      this.$emit("reset");
    },
  },
  watch: {
    //필터의 값이 바뀌면 바뀐값을 store에 저장하고 필터링액션을 상위컴포넌트에 전달합니다.
    filters: {
      deep: true,
      handler() {
        this.$store.dispatch("auctionModule/setFilter", this.filters);
        this.$store.dispatch("auctionModule/setPage", 1);
        this.$emit("filtering");
      }
    },
  },
  mounted() {
    // 시 정보 가져오기 
    itemApi.search(null).then((res: AxiosResponse) => {
      this.Si = res.data.object.districts;
    })
    // 구 정보 가져오기
    itemApi.search(this.filters.si).then((res: AxiosResponse) => {
      this.Gu = res.data.object.gungu;
    })
  }
});
